import { render, staticRenderFns } from "./blood-oxygen-report-configuration.vue?vue&type=template&id=7ac95d76&scoped=true"
import script from "./blood-oxygen-report-configuration.vue?vue&type=script&lang=js"
export * from "./blood-oxygen-report-configuration.vue?vue&type=script&lang=js"
import style0 from "./blood-oxygen-report-configuration.vue?vue&type=style&index=0&id=7ac95d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac95d76",
  null
  
)

export default component.exports